export interface IFlightSegmentConnectorProps {
  classNames?: Partial<{
    root: string;
    marker: string;
    line: string;
  }>;
}

/**
 * Visually connects the two termini of a flight segment: a marker at the
 * departure, a connecting line, and a marker at the arrival.
 */
export const FlightSegmentConnector = ({
  classNames,
}: IFlightSegmentConnectorProps) => (
  <div className={classNames?.root}>
    <div className={classNames?.marker}></div>
    <div className={classNames?.line}></div>
    <div className={classNames?.marker}></div>
  </div>
);
